import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, } from "react";
import { Field } from "formik";
import { styled } from "../../theme";
import { Select } from "../atoms/select";
import { FieldError } from "../atoms/field-error";
import { FloatingFieldLabel } from "../atoms/FloatingFieldLabel";
import { FieldBorder } from "../atoms/FieldBorder";
import { PLACEHOLDER_OPTION_VALUE } from "../atoms/select/Select";
import { Label } from "../atoms/Label";
import { isInvalid } from "../formHelpers";
/**
 * A customizable select field component for use with Formik.
 *
 * @param {SelectFieldProps<T>} props The props for the component.
 * @returns {JSX.Element} The rendered select field component.
 */
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
export const SelectField = ({ name, label, options, placeholder, getOptionLabel, getOptionValue, onChange, FormField, ...inputProps }) => {
    const [focused, setFocus] = useState(false);
    return (_jsx(FormField, { name: name, children: ({ field, form }) => {
            const value = field.value || PLACEHOLDER_OPTION_VALUE;
            return (_jsxs(Label, { children: [_jsx(FloatingFieldLabel, { visible: true, uppercase: true, children: label }), _jsx(SelectWrapper, { children: _jsxs(Select, { ...field, ...inputProps, value: value, onFocus: () => setFocus(true), onBlur: (event) => {
                                setFocus(false);
                                field.onBlur(event);
                            }, onChange: (event) => {
                                if (event.target.value !== PLACEHOLDER_OPTION_VALUE) {
                                    field.onChange(field.name)(event.target.value);
                                    onChange?.(event);
                                }
                            }, children: [placeholder || label ? (_jsx("option", { value: PLACEHOLDER_OPTION_VALUE, disabled: true, children: placeholder ?? label })) : null, options.map(option => (_jsx("option", { value: getOptionValue(option), children: getOptionLabel(option) }, getOptionValue(option))))] }) }), _jsx(FieldBorder, { focused: focused, invalid: isInvalid(name, form) }), _jsx(FieldError, { name: name })] }));
        } }));
};
SelectField.defaultProps = {
    getOptionLabel: (option) => option.label,
    getOptionValue: (option) => option.value,
    FormField: Field,
};
const SelectWrapper = styled.div `
  display: flex;
  align-items: center;
`;
